import React, { useState } from "react";
import { Button, Grid, TextField, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

import { ListItem } from "../ListItem/ListItem";

import { useStyles } from "./MultiInputBox.styles";

/*
  How to use the component
  <MultiInputBox
    btnLabel="Add"
    btnIcon={<Add></Add>}
    onAdd={(a) => {
      console.log(a);
    }}
    emptyImg={releasetarget}
    description={
      <>
        <b>There are no targets selected yet.</b> &nbsp;Release is not
        being deistributed.
      </>
    }
    list={[
      { name: "VFU0019897", id: 1 },
      { name: "FU897687", id: 2 },
      { name: "FU897687", id: 3 },
    ]}
    >
  </MultiInputBox> 
*/

const MultiInputBox = ({
  btnLabel,
  btnIcon,
  onAdd,
  secondaryBtnLabel,
  secondaryBtnIcon,
  onSecondaryAction,
  emptyImg,
  description,
  list,
  placeholder,
  onDelete,
  isAddEnabled,
  isDeleteEnabled,
  redirect,
}) => {
  const classes = useStyles();
  const [value, setValue] = useState("");
  const history = useHistory();

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const add = () => {
    if (value) {
      const targets = value.split(",");
      onAdd(targets);
      setValue("");
    }
  };

  const onRemove = async () => {
    if (value) {
      const targets = value
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);
      onSecondaryAction(targets, {
        onSuccess: () => {
          setValue("");
        },
      });
    }
  };

  return (
    <div id="multiInputBox" className={classes.multiInputBox}>
      {isAddEnabled && (
        <div className={classes.inputBox}>
          <TextField
            fullWidth
            placeholder={placeholder}
            id="multi-input-box"
            value={value}
            onChange={handleChange}
            className={classes.input}
          />
          <Button
            color="primary"
            disableRipple
            className={classes.add}
            onClick={add}
          >
            {btnIcon}
            {btnLabel}
          </Button>
          {(secondaryBtnIcon || secondaryBtnLabel) && (
            <Button
              color="primary"
              disableRipple
              className={classes.add}
              onClick={onRemove}
            >
              {secondaryBtnIcon}
              {secondaryBtnLabel}
            </Button>
          )}
        </div>
      )}

      {list.length === 0 ? (
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className={classes.empty}
        >
          <img src={emptyImg} className={classes.img} alt="empty"></img>
          <Typography variant="h6" className={classes.desc}>
            {description}
          </Typography>
        </Grid>
      ) : (
        <Grid className={classes.list}>
          {list.map((item, index) => {
            return (
              <ListItem
                key={index}
                label={item.value}
                del={() => {
                  onDelete(item.value);
                }}
                isBadgeEnabled={false}
                isDeleteEnabled={isDeleteEnabled}
                redirect={redirect}
                detail={() => {
                  history.push("/dashboard/units/" + item?.value);
                }}
              ></ListItem>
            );
          })}
        </Grid>
      )}
    </div>
  );
};

MultiInputBox.defaultProps = {
  isAddEnabled: true,
  isDeleteEnabled: true,
  redirect: true,
};

MultiInputBox.propTypes = {
  btnLabel: PropTypes.string,
  btnIcon: PropTypes.node,
  onAdd: PropTypes.func,
  onDelete: PropTypes.func,
  secondaryBtnLabel: PropTypes.string,
  secondaryBtnIcon: PropTypes.string,
  onSecondaryAction: PropTypes.func,
  //onDetail: PropTypes.func,
  emptyImg: PropTypes.any,
  description: PropTypes.node,
  list: PropTypes.array,
  placeholder: PropTypes.string,
  isAddEnabled: PropTypes.bool,
  isDeleteEnabled: PropTypes.bool,
  redirect: PropTypes.bool,
};

export { MultiInputBox };
